import { Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { HelpersService } from 'src/app/services';

@Component({
  selector: 'app-workshop-jobcard-notes-preview',
  templateUrl: './workshop-jobcard-notes-preview.component.html',
  styleUrls: ['./workshop-jobcard-notes-preview.component.scss']
})
export class WorkshopJobcardNotesPreviewComponent {
  @Input() noteType: string = '';
  @Input() notes: any[] = [];

  countryData: any = this.helpersService.getCountryData();

  constructor(
    private translate: TranslateService,
    private helpersService: HelpersService
  ) { }

  getNoteTypeTitle(): string {
    switch (this.noteType) {
      case 'INTERNAL':
        return this.translate.instant('bikeshop.modal.update_job_card.job_card.internal_notes');
      case 'EXTERNAL':
        return this.translate.instant('bikeshop.modal.update_job_card.job_card.external_notes');
      case 'CLIENTNOTES':
        return this.translate.instant('bikeshop.modal.update_job_card.job_card.customer_notes');
      default:
        return 'Notes';
    }
  }

  getSortedNotes() {
    return this.notes.sort((a, b) =>
      new Date(b.createdDate).getTime() - new Date(a.createdDate).getTime()
    );
  }

  shouldShowDateSeparator(note: any, index: number): boolean {
    if (index === 0) return true;

    const sortedNotes = this.getSortedNotes();
    const currentDate = new Date(note.createdDate).toDateString();
    const previousDate = new Date(sortedNotes[index - 1].createdDate).toDateString();

    return currentDate !== previousDate;
  }

  getDateDisplayText(dateString: string): string {
    const noteDate = new Date(dateString);
    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(yesterday.getDate() - 1);

    if (noteDate.toDateString() === today.toDateString()) {
      return this.translate.instant('bikeshop.workshop.jobcard.manage.messaging.today');
    } else if (noteDate.toDateString() === yesterday.toDateString()) {
      return this.translate.instant('bikeshop.workshop.jobcard.manage.messaging.yesterday');
    } else {
      return this.translate.instant('bikeshop.workshop.jobcard.manage.messaging.older');
    }
  }
}
